<script setup>
import { Head } from "@inertiajs/inertia-vue3";
import Navbar from "@/Components/Navbar.vue";
import { ref, onMounted, watch } from "vue";
import HeaderLink from "@/Components/Settings/HeaderLink.vue";
import HeaderButton from "@/Components/Settings/HeaderButton.vue";

const props = defineProps({
  practitioner: Object,
  date: String,
  appointments: Object,
  openingHours: Object,
  interval: Number,
  slots: Object,
});

const backUrl = ref("/");
const days = ["So.", "Mo.", "Di.", "Mi.", "Do.", "Fr.", "Sa."];
const dateString = ref(
  days[new Date(props.date).getDay()] +
    " " +
    new Date(props.date).toLocaleDateString("de")
);
const showComments = ref(false);
//const slots = ref([]);
//const appointments = ref([]);
//const openingHours = ref([]);
//const interval = ref(0);

watch(showComments, (val) => {
  // console.log(val);
});

onMounted(() => {
  //    console.log(props.slots);
  // console.log(props);
  //    axios
  //        .get("/generatePrintOverview", {
  //            params: {
  //                practitioner: props.practitioner.id,
  //                date: props.date,
  //            },
  //        })
  //        .then((res) => {
  //            console.log("res", res.data);
  //            //slots.value = res.data.slots;
  //            //Object.entries(res.data.appointments).forEach(([i, v]) => {
  //            //    if (v.username == props.practitioner.username) {
  //            //        appointments.value = v.appointments;
  //            //    }
  //            //});
  //            //openingHours.value = res.data.openingHours;
  //            //interval.value = res.data.interval;
  //        });
});

function testForAppointment(slot, is_parallel = 0) {
  let size;
  let type;
  let slotDate = new Date(slot.date);
  // handle timezone
  var userTimezoneOffset = slotDate.getTimezoneOffset() * 60000;
  slotDate = new Date(slotDate.getTime() + userTimezoneOffset);

  // get starting dates
  let hit = props.appointments.filter(function (data) {
    return (
      data.is_parallel == is_parallel &&
      slotDate >= new Date(data.start) &&
      slotDate < new Date(data.end)
    );
  });

  if (hit.length) {
    let endDate = new Date(hit[0].end);
    let diffInMilli = Math.abs(slotDate - endDate);
    let diffInMin = Math.floor(diffInMilli / 1000 / 60);

    if (diffInMin < 5 * 60) {
      // should be max 5 hours
      size = diffInMin / props.interval;
    } else {
      size = 1;
    }

    endDate.setMinutes(endDate.getMinutes() - props.interval);
    if (new Date(hit[0].start).getTime() === slotDate.getTime()) {
      if (endDate.getTime() === slotDate.getTime()) {
        type = "single";
      } else {
        type = "start";
      }
    } else if (endDate.getTime() === slotDate.getTime()) {
      type = "end";
    } else {
      type = "mid";
    }

    return { size: size, type: type, appointment: hit[0] };
  }

  return false;
}

function backClicked() {
  //backUrl.value = window.history.back();
  backUrl.value = "/kalender";
}

function openPrint() {
  window.print();
}
</script>

<template>
  <!-- Printview -->
  <div class="printonly">
    <div class="mb-8 flex">
      <div>
        <h2>
          <b>{{ dateString }}</b>
        </h2>
        <h2>
          <b
            >{{ practitioner.title }} {{ practitioner.firstname }}
            {{ practitioner.lastname }}</b
          >
        </h2>
      </div>

      <div class="ml-auto">
        <img src="/storage/landing/logo-oteo.png" width="150" />
      </div>
    </div>

    <hr />

    <table class="printviewtable">
      <thead>
        <th></th>
        <th>Behandlungen</th>
        <th>Parallelbehandlungen</th>
      </thead>
      <tbody>
        <tr v-for="(slot, index) in props.slots">
          <!-- time -->
          <td>
            {{ slot.text }}
          </td>

          <!-- appointment -->
          <td
            v-if="
              (hit = testForAppointment(slot, 0)).type == 'start' ||
              (hit = testForAppointment(slot, 0)).type == 'single'
            "
            :rowspan="hit.size"
            class="appointment-slot"
          >
            <div class="">
              <div class="flex">
                <b class="mr-2">{{ hit.appointment.patient_name }}</b>

                <span class="opacity-70 mr-2">{{
                  hit.appointment.type.name
                }}</span>

                <div class="ml-auto flex">
                  <!-- practitioner -->
                  <div
                    class="px-0.5 text-slotBadgeBorder border border-slotBadgeBorder rounded mr-1 mt-0.5"
                    :title="hit.appointment.user_fullname"
                  >
                    <small>{{ hit.appointment.user_name }}</small>
                  </div>

                  <!-- type -->
                  <div
                    class="px-0.5 text-slotBadgeBorder border border-slotBadgeBorder rounded mr-1 mt-0.5"
                    :style="`background-color:${hit.appointment.color};color:#fff`"
                    :title="
                      hit.appointment.type_name +
                      (hit.appointment.is_series ? ' - Terminserie' : '')
                    "
                  >
                    <small
                      >{{ hit.appointment.type_abbreviation
                      }}<span v-if="hit.appointment.is_series">+</span></small
                    >
                  </div>

                  <!-- Room -->
                  <div
                    class="px-0.5 text-slotBadgeBorder border border-slotBadgeBorder rounded mr-1 mt-0.5"
                    :title="
                      'Behandlungsraum ' + hit.appointment.room_abbreviation
                    "
                  >
                    <small>{{ hit.appointment.room_abbreviation }}</small>
                  </div>
                </div>
              </div>

              <div
                class="flex"
                v-if="showComments && hit.appointment.description"
              >
                <div class="mr-2">
                  <b><small>Anmerkung:</small></b>
                </div>
                <div class="flex-1">
                  <small>{{ hit.appointment.description }}</small>
                </div>
              </div>
            </div>
          </td>
          <td v-else-if="(hit = testForAppointment(slot, 0)) == false"></td>

          <!-- parallel -->
          <td
            v-if="
              (hitp = testForAppointment(slot, 1)).type == 'start' ||
              (hitp = testForAppointment(slot, 1)).type == 'single'
            "
            :rowspan="hitp.size"
            class="appointment-slot"
          >
            <div class="">
              <div class="flex">
                <b class="mr-2">{{ hitp.appointment.patient_name }}</b>

                <span class="opacity-70 mr-2">{{
                  hitp.appointment.type.name
                }}</span>

                <div class="ml-auto flex">
                  <!-- practitioner -->
                  <div
                    class="px-0.5 text-slotBadgeBorder border border-slotBadgeBorder rounded mr-1 mt-0.5"
                    :title="hitp.appointment.user_fullname"
                  >
                    <small>{{ hitp.appointment.user_name }}</small>
                  </div>

                  <!-- type -->
                  <div
                    class="px-0.5 text-slotBadgeBorder border border-slotBadgeBorder rounded mr-1 mt-0.5"
                    :style="`background-color:${hitp.appointment.color};color:#fff`"
                    :title="
                      hitp.appointment.type_name +
                      (hitp.appointment.is_series ? ' - Terminserie' : '')
                    "
                  >
                    <small
                      >{{ hitp.appointment.type_abbreviation
                      }}<span v-if="hitp.appointment.is_series">+</span></small
                    >
                  </div>

                  <!-- Room -->
                  <div
                    class="px-0.5 text-slotBadgeBorder border border-slotBadgeBorder rounded mr-1 mt-0.5"
                    :title="
                      'Behandlungsraum ' + hitp.appointment.room_abbreviation
                    "
                  >
                    <small>{{ hitp.appointment.room_abbreviation }}</small>
                  </div>
                </div>
              </div>

              <div
                class="flex"
                v-if="showComments && hitp.appointment.description"
              >
                <div class="mr-2">
                  <b><small>Anmerkung:</small></b>
                </div>
                <div class="flex-1">
                  <small>{{ hitp.appointment.description }}</small>
                </div>
              </div>
            </div>
          </td>
          <td v-else-if="(hitp = testForAppointment(slot, 1)) == false"></td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Webview -->
  <div
    id="theme-wrapper"
    style="background-image: url('/storage/img/auth_bg.jpg')"
    class="bg-cover bg-no-repeat flex bg-oteoBlue-600 noprint"
    :class="'theme-' + $page.props.theme ?? 'spitta'"
  >
    <Head title="Druckansicht" />
    <Navbar class="navbar-sub w-full" />

    <div class="bg-white w-full max-w-8xl mx-auto mt-[80px] mb-8 rounded-xl">
      <header
        class="bg-gray-100 flex justify-between items-center px-12 py-8 rounded-tl-xl rounded-tr-xl relative"
      >
        <div class="py-3">
          <h2 class="text-3xl font-semibold mr-8 mb-1">
            {{ practitioner.title }} {{ practitioner.firstname }}
            {{ practitioner.lastname }}
          </h2>
          <div class="text-gray-500 opacity-80">
            {{ dateString }}
          </div>
        </div>

        <div class="flex relative">
          <HeaderLink
            @click="backClicked"
            :href="backUrl"
            type="close"
            class="mr-3"
            >Zurück</HeaderLink
          >
          <HeaderButton @click="openPrint()">Drucken</HeaderButton>
        </div>
      </header>

      <div class="flex pt-6 px-12">
        <div class="flex items-center">
          <input type="checkbox" id="showComments" v-model="showComments" />
          <label class="ml-2 font-semibold select-none" for="showComments"
            >mit Anmerkungen</label
          >
        </div>
      </div>

      <div class="flex pt-6 pb-12 px-12 relative">
        <div class="w-[100%] h-100 pb-8">
          <table class="printviewtable">
            <thead>
              <th></th>
              <th>Behandlungen</th>
              <th>Parallelbehandlungen</th>
            </thead>
            <tbody>
              <tr v-for="(slot, index) in props.slots">
                <!-- time -->
                <td>
                  {{ slot.text }}
                </td>

                <!-- appointment -->
                <td
                  v-if="
                    (hit = testForAppointment(slot, 0)).type == 'start' ||
                    (hit = testForAppointment(slot, 0)).type == 'single'
                  "
                  :rowspan="hit.size"
                  class="appointment-slot"
                >
                  <div class="">
                    <div class="flex">
                      <b class="mr-2">{{ hit.appointment.patient_name }}</b>

                      <span class="opacity-70 mr-2">{{
                        hit.appointment.type.name
                      }}</span>

                      <div class="ml-auto flex">
                        <!-- practitioner -->
                        <div
                          class="px-0.5 text-slotBadgeBorder border border-slotBadgeBorder rounded mr-1 mt-0.5"
                          :title="hit.appointment.user_fullname"
                        >
                          <small>{{ hit.appointment.user_name }}</small>
                        </div>

                        <!-- type -->
                        <div
                          class="px-0.5 text-slotBadgeBorder border border-slotBadgeBorder rounded mr-1 mt-0.5"
                          :style="`background-color:${hit.appointment.color};color:#fff`"
                          :title="
                            hit.appointment.type_name +
                            (hit.appointment.is_series ? ' - Terminserie' : '')
                          "
                        >
                          <small
                            >{{ hit.appointment.type_abbreviation
                            }}<span v-if="hit.appointment.is_series"
                              >+</span
                            ></small
                          >
                        </div>

                        <!-- Room -->
                        <div
                          class="px-0.5 text-slotBadgeBorder border border-slotBadgeBorder rounded mr-1 mt-0.5"
                          :title="
                            'Behandlungsraum ' +
                            hit.appointment.room_abbreviation
                          "
                        >
                          <small>{{ hit.appointment.room_abbreviation }}</small>
                        </div>
                      </div>
                    </div>

                    <div
                      class="flex"
                      v-if="showComments && hit.appointment.description"
                    >
                      <div class="mr-2">
                        <b><small>Anmerkung:</small></b>
                      </div>
                      <div class="flex-1">
                        <small>{{ hit.appointment.description }}</small>
                      </div>
                    </div>
                  </div>
                </td>
                <td
                  v-else-if="(hit = testForAppointment(slot, 0)) == false"
                ></td>

                <!-- parallel -->
                <td
                  v-if="
                    (hitp = testForAppointment(slot, 1)).type == 'start' ||
                    (hitp = testForAppointment(slot, 1)).type == 'single'
                  "
                  :rowspan="hitp.size"
                  class="appointment-slot"
                >
                  <div class="">
                    <div class="flex">
                      <b class="mr-2">{{ hitp.appointment.patient_name }}</b>

                      <span class="opacity-70 mr-2">{{
                        hitp.appointment.type.name
                      }}</span>

                      <div class="ml-auto flex">
                        <!-- practitioner -->
                        <div
                          class="px-0.5 text-slotBadgeBorder border border-slotBadgeBorder rounded mr-1 mt-0.5"
                          :title="hitp.appointment.user_fullname"
                        >
                          <small>{{ hitp.appointment.user_name }}</small>
                        </div>

                        <!-- type -->
                        <div
                          class="px-0.5 text-slotBadgeBorder border border-slotBadgeBorder rounded mr-1 mt-0.5"
                          :style="`background-color:${hitp.appointment.color};color:#fff`"
                          :title="
                            hitp.appointment.type_name +
                            (hitp.appointment.is_series ? ' - Terminserie' : '')
                          "
                        >
                          <small
                            >{{ hitp.appointment.type_abbreviation
                            }}<span v-if="hitp.appointment.is_series"
                              >+</span
                            ></small
                          >
                        </div>

                        <!-- Room -->
                        <div
                          class="px-0.5 text-slotBadgeBorder border border-slotBadgeBorder rounded mr-1 mt-0.5"
                          :title="
                            'Behandlungsraum ' +
                            hitp.appointment.room_abbreviation
                          "
                        >
                          <small>{{
                            hitp.appointment.room_abbreviation
                          }}</small>
                        </div>
                      </div>
                    </div>

                    <div
                      class="flex"
                      v-if="showComments && hitp.appointment.description"
                    >
                      <div class="mr-2">
                        <b><small>Anmerkung:</small></b>
                      </div>
                      <div class="flex-1">
                        <small>{{ hitp.appointment.description }}</small>
                      </div>
                    </div>
                  </div>
                </td>
                <td
                  v-else-if="(hitp = testForAppointment(slot, 1)) == false"
                ></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
table.printviewtable {
  table-layout: fixed;
  width: 100%;
}

table.printviewtable th,
table.printviewtable td {
  border: 1px solid black;
  width: 60%;
  height: 35px;
  overflow: hidden;
  text-align: left;
  vertical-align: top;
  padding: 4px 3px 4px 10px;
}

table.printviewtable th:first-of-type,
table.printviewtable td:first-of-type {
  width: 10%;
  text-align: center;
}

table.printviewtable th:last-of-type,
table.printviewtable td:last-of-type {
  width: 30%;
}
table.printviewtable td.appointment-slot {
  background-color: #efefef !important;
  -webkit-print-color-adjust: exact;
  print-color-adjust: exact;
}

/* print view properties */
.printonly {
  display: none;
}

@media print {
  @page {
    size: landscape;
    margin-top: 0.9cm;
    margin-left: 0;
    margin-right: 0;
  }
  body {
    margin: 0 1.5cm;
  }
  .noprint,
  .noprint * {
    display: none;
  }
  .printonly {
    display: block;
  }

  table.printviewtable th,
  table.printviewtable td {
    font-size: 80%;
    line-height: 1;
    height: 10px;
  }

  table.printviewtable td.appointment-slot {
    background-color: #efefef !important;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }
}
</style>
